import PropTypes from 'prop-types'
import { Helmet } from 'react-helmet-async'

import { getQueryParamsFromHash, parsePermittedQueryParams } from '@domain-group/javascript-utils'

import { Box, Button, Columns } from '@domain-group/suit-theme'

import ImpersonateEntityButton from '@components/ImpersonateEntityButton'
import PageHeader from '@components/PageHeader'
import ScopedConditionalContent from '@components/ScopedConditionalContent'

import useCurrentUser from '@hooks/useCurrentUser'
import useSystemManagerNestedNavigation from '@hooks/useSystemManagerNestedNavigation'

import generateTabBarItems from '../../utils/generateTabBarItems'

const PageLayout = (props) => {
  const { activeTabBarItemKey, children, entityPayload } = props

  const {
    provider,
    callbacks: { loginAsProvider },
    urls: { providersIndexUrl },
  } = entityPayload

  const { redirect } = parsePermittedQueryParams(getQueryParamsFromHash(), ['redirect'])

  const { shouldUseNestedNavigation } = useSystemManagerNestedNavigation()

  const { isAdmin } = useCurrentUser()

  return (
    <>
      <Helmet>
        <title>Edit Provider | Realhub</title>
      </Helmet>

      <PageHeader
        actionContent={(
          <ScopedConditionalContent permittedRoleTitles={['Admin', 'Support']}>
            <ImpersonateEntityButton
              callbacks={{ loginAsEntity: loginAsProvider }}
              entity={provider}
              marginRight="medium"
            />

            <Button
              as="a"
              buttonStyle="secondaryUtility"
              href={redirect || providersIndexUrl}
              size="medium"
              width="auto"
            >
              Back
            </Button>
          </ScopedConditionalContent>
        )}
        activeTabBarItemKey={activeTabBarItemKey}
        nestedNavigation={shouldUseNestedNavigation}
        tabBarItems={generateTabBarItems({ isAdmin, provider })}
        title="Edit Provider"
      />

      <Box paddingX="large" paddingTop={[112, 105]}>
        <Columns boxProps={{ marginTop: 'large' }} flexDirection={['column', 'column', 'row']}>
          {children}
        </Columns>
      </Box>
    </>
  )
}

PageLayout.propTypes = {
  activeTabBarItemKey: PropTypes.string,
  children: PropTypes.node.isRequired,
  entityPayload: PropTypes.shape({
    provider: PropTypes.object.isRequired,
    callbacks: PropTypes.shape({
      loginAsProvider: PropTypes.func.isRequired,
    }).isRequired,
    urls: PropTypes.shape({
      providersIndexUrl: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
}

export default PageLayout
